import React from "react";
import { InputMentorshipTask, MentorshipTask } from "../../server/serverTypes";
import EditTask from "../views/EditTask";
import { useTask } from "../redux/hooks";
import { SRD } from "srd";
import ErrorPage from "../../components/ErrorPage";
import LoadingPage from "../../components/LoadingPage";
import { useProgramInfo } from "../../mentor/redux/hooks";
import { useDispatch } from "react-redux";
import { actions } from "../redux/model";

interface IEditTaskContainer {
  id: string;
}

const EditTaskContainer = ({ id }: IEditTaskContainer) => {
  const taskRd = useTask(Number(id));
  const mp = useProgramInfo();
  const dispatch = useDispatch();

  const handleUpdate = (val: {
    id: number;
    title: string;
    description: string;
    dueDate: Date;
  }) => {
    if (mp) {
      const taskObj: InputMentorshipTask = {
        id: val.id,
        title: val.title,
        description: val.description,
        dueDate: val.dueDate,
        fkMentorshipId: mp.id,
      };
      dispatch(actions.editMentorshipTask(taskObj));
    }
  };

  return SRD.match(
    {
      notAsked: () => <LoadingPage />,
      loading: () => <LoadingPage />,
      failure: (msg: Error) => <ErrorPage />,
      success: (task: MentorshipTask) => (
        <EditTask task={task} updateTask={handleUpdate} />
      ),
    },
    taskRd
  );
};

export default EditTaskContainer;
